var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomCircles1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 375,
    viewBox: "0 0 374 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.12891,
    y: 373.016,
    width: 371.872,
    height: 371.872,
    rx: 185.936,
    transform: "rotate(-90 1.12891 373.016)",
    fill: "#F8F9F9",
    fillOpacity: 0.48,
    stroke: "url(#paint0_linear_1332_673)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0078,
    y: 345.135,
    width: 316.112,
    height: 316.112,
    rx: 158.056,
    transform: "rotate(-90 29.0078 345.135)",
    fill: "#F8F9F9",
    fillOpacity: 0.48,
    stroke: "url(#paint1_linear_1332_673)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1332_673",
    x1: 2.12892,
    y1: 530.039,
    x2: 406.386,
    y2: 852.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E2EBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1332_673",
    x1: 15.6189,
    y1: 450.023,
    x2: 279.86,
    y2: 830.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E2EBF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomCircles1);
export default __webpack_public_path__ + "static/media/bottom-circles1.ff74f039fe4c405b5e7056d47293e3e6.svg";
export { ForwardRef as ReactComponent };